import type { CargoItemStatusType, TCargoType } from 'api/swagger';

export enum CargoCustomRequirements {
  'without_custom' = 'without_custom',
  'custom_in_place' = 'custom_in_place',
  'our_custom_clearance' = 'our_custom_clearance',
  'need_address' = 'need_address',
}

export type CargoCustomRequirementsType =
  | 'without_custom'
  | 'custom_in_place'
  | 'our_custom_clearance'
  | 'need_address';

export const CARGO_STATUS_WAITING = 'waiting';
export const CARGO_STATUS_PLANNED = 'planned';
export const CARGO_STATUS_WAREHOUSE = 'warehouse';
export const CARGO_STATUS_LOADED = 'loaded';
export const CARGO_STATUS_DELIVERED = 'delivered';

export const CARGO_STATUSES: CargoItemStatusType[] = [
  CARGO_STATUS_WAITING,
  CARGO_STATUS_PLANNED,
  CARGO_STATUS_WAREHOUSE,
  CARGO_STATUS_LOADED,
  CARGO_STATUS_DELIVERED,
];

export const CargoType: Record<TCargoType, TCargoType> = {
  FTL: 'FTL',
  LTL: 'LTL',
  CONTAINER: 'CONTAINER',
  PART_LOAD: 'PART_LOAD',
};

export const COMPLEX_STATUS_ALL_IN_PROGRESS = 'all_in_progress';

export type TComplexStatusType = 'all_in_progress' | 'waiting' | 'planned' | 'warehouse' | 'loaded' | 'delivered';

export const COMPLEX_STATUS_OPTIONS: TComplexStatusType[] = [
  COMPLEX_STATUS_ALL_IN_PROGRESS,
  CARGO_STATUS_WAITING,
  CARGO_STATUS_PLANNED,
  CARGO_STATUS_WAREHOUSE,
  CARGO_STATUS_LOADED,
  CARGO_STATUS_DELIVERED,
];
